import type React from 'react';

import { useGetUser } from '@vlabs/api/artemy/client';
import type { UserId } from '@vlabs/api/artemy/model';
import { UserIcon } from '@vlabs/icons';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './DepartmentUser.module.sass';
import { Link } from '../../../shared/ui/link';

interface DepartmentUserProps extends WithDataTestid {
  userId: UserId;
  actions?: React.ReactNode[];
}

const displayName = 'DepartmentUser';
const testid = buildTestid(displayName);

function DepartmentUser({
  userId,
  actions = undefined,
  'data-testid': dataTestId = undefined,
}: DepartmentUserProps): React.JSX.Element {
  const { data: user } = useGetUser(userId);

  return (
    <div
      className={st.Root}
      {...testid(dataTestId)}
    >
      <div className={st.UserLinkIcon}>
        <UserIcon className={st.Icon} />
        <Link
          to={generatePath(routes.users.view, { userId })}
          type="secondary"
          {...testid('Link', dataTestId)}
        >
          {user?.email}
        </Link>
      </div>

      {!!actions?.length && (
        <div
          className={st.Actions}
          {...testid('Actions', dataTestId)}
        >
          {actions}
        </div>
      )}
    </div>
  );
}

DepartmentUser.displayName = displayName;

export { DepartmentUser };
